import { Checkbox, Group, Text } from '@mantine/core'
import styles from './LXCards.module.scss'

type LXCardProps<T> = {
  roleItem: {
    value: T
    label: string
    description?: string | JSX.Element
  }
  readonly?: boolean
}

export const LXCard = <T extends string>({ roleItem, readonly = false }: LXCardProps<T>) => {
  return (
    <Checkbox.Card
      className={`${styles.root} ${readonly ? styles.readonly : ''}`}
      radius="md"
      value={roleItem.value}
      key={roleItem.label}
      disabled={readonly}
      hidden
    >
      <Group wrap="nowrap" align="flex-start">
        {!readonly && <Checkbox.Indicator size="xs" />}
        <div>
          <Text size="xs" ff="monospace" fw="bold" lh={1.3} c="var(--mantine-color-bright)">
            {roleItem.label}
          </Text>
          {roleItem.description && (
            <Text size="xs" opacity="0.4" mt="0.5rem">
              {roleItem.description}
            </Text>
          )}
        </div>
      </Group>
    </Checkbox.Card>
  )
}
